import { APIService } from '../../../lib/api/APIService';

// Landing chat handoff API — public prompt catalogue, anonymous expiring
// handoff creation/resume, and the authenticated retry-claim endpoint.
// Tokens are always request-body fields, never path/query parameters.
class LandingHandoffAPI extends APIService {
  async getPromptCatalogue(surface) {
    return this.get(`/api/landing-chat/prompts?surface=${encodeURIComponent(surface)}`, { skipAuth: true });
  }

  async createHandoff(promptId) {
    return this.post('/api/landing-chat/handoffs', { prompt_id: promptId }, { skipAuth: true });
  }

  async resumeHandoff(handoffToken) {
    return this.post(
      '/api/landing-chat/handoffs/resume',
      { handoff_token: handoffToken },
      { skipAuth: true }
    );
  }

  async retryClaim({ handoffToken, handoffRetryToken } = {}) {
    const body = handoffToken
      ? { handoff_token: handoffToken }
      : { handoff_retry_token: handoffRetryToken };
    return this.post('/api/landing-chat/handoffs/claim', body);
  }
}

// Create and export landing handoff API instance
export const landingHandoffAPI = new LandingHandoffAPI();
